export const UNATTENDED_WARNING_SECONDS = 10 * 60;
export const UNATTENDED_CRITICAL_SECONDS = 15 * 60;

export const normalizeTimestamp = value => {
  if (!value) return null;

  const numberValue = Number(value);

  if (Number.isFinite(numberValue)) {
    return numberValue > 9999999999
      ? Math.floor(numberValue / 1000)
      : numberValue;
  }

  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? null : Math.floor(parsed / 1000);
};

export const getUnattendedAlertLevel = (
  conversation,
  nowInSeconds = Math.floor(Date.now() / 1000)
) => {
  let waitingSince;
  if (conversation?.meta?.assignee?.id) {
    waitingSince = normalizeTimestamp(conversation?.agent_waiting_since);
  } else if (conversation?.meta?.team?.id) {
    // Team-only chat: clock starts at team assignment or the customer's later unanswered message.
    const customerWaiting = normalizeTimestamp(conversation?.waiting_since);
    const teamAssigned = normalizeTimestamp(conversation?.team_assigned_at);
    waitingSince = customerWaiting && Math.max(customerWaiting, teamAssigned || 0);
  }

  if (!waitingSince) return '';

  const waitingAge = nowInSeconds - waitingSince;

  if (waitingAge >= UNATTENDED_CRITICAL_SECONDS) return 'critical';
  if (waitingAge >= UNATTENDED_WARNING_SECONDS) return 'warning';

  return '';
};
